<template>
  <div>
    <template>
      <div class="d-flex flex-column w-100">
        <h5 v-if="hasTitle && show_title" class="mb-1 skinc-title5" :style="titleStyle">
          <span v-if="lang === 'KOR'">
            {{ disclosureInfo.image_title }}
          </span>
          <span v-else>
            {{ disclosureInfo.image_title_em || disclosureInfo.image_title_ea }}
          </span>
        </h5>

        <div
          align="center"
          class="d-flex mb-2 text-center"
          :class="imageAlignmentClass"
          :style="{ overflow: 'visible' }"
          @click="openImgPopup"
        >
          <b-img
            v-if="lang === 'KOR'"
            :style="{ width: disclosureInfo.image_width + '%' }"
            class="border-radius"
            :src="imageUrl"
            @load="onImageLoad"
          />
          <b-img
            v-else
            :style="{ width: disclosureInfo.image_width + '%' }"
            class="border-radius"
            :src="imageUrlE"
            @load="onImageLoad"
          />
        </div>
        <div v-if="hasCaption">
          <p class="skinc-comment" :style="[captionStyle, { whiteSpace: 'pre-line' }]">
            <span v-if="content_caption !== 'null'">
              {{ content_caption }}
            </span>
          </p>
        </div>
      </div>
    </template>
    <!-- 
    <template v-else>
      <b-row>
        <b-col cols="2" v-if="show_title">
          <h6 v-if="hasTitle" class="mb-3 fw-600 gray-800 border-top-dark pt-2">
            <span v-if="lang === 'KOR'">
              {{ disclosureInfo.image_title }}
            </span>
            <span v-else>
              {{ disclosureInfo.image_title_em || disclosureInfo.image_title_ea }}
            </span>
          </h6>
        </b-col>
        <b-col cols="10" :offset="show_title ? 0 : 2">
          <div align="center" class="d-flex mb-2 text-center" :class="imageAlignmentClass"
            :style="{ overflow: 'visible' }" @click="openImgPopup">
            <b-img v-if="lang === 'KOR'" :style="{ width: disclosureInfo.image_width + '%' }"  :src="imageUrl"  @load="onImageLoad"/>
            <b-img v-else :style="{ width: disclosureInfo.image_width + '%' }"  :src="imageUrlE"  @load="onImageLoad"/>
          </div>

          <div v-if="hasCaption">
            <p class="fw-400 f-90" style="white-space: pre-line">
              <span v-if="lang === 'KOR'">
                {{ disclosureInfo.image_caption }}
              </span>
              <span v-else>
                {{ disclosureInfo.image_caption_em || disclosureInfo.image_caption_ea }}
              </span>
            </p>
          </div>
        </b-col>
      </b-row>
    </template> -->
  </div>
</template>

<script>
export default {
  name: 'ImageContent',
  props: {
    disclosureInfo: { type: Object, required: true },
    lang: { type: String, required: true },
    print_mode: { type: Boolean, default: false },
    show_title: { type: Boolean, default: true }
  },
  computed: {
    hasTitle() {
      return (
        this.disclosureInfo.image_title &&
        this.disclosureInfo.image_title !== 'null' &&
        this.disclosureInfo.image_title !== ' '
      );
    },
    content_caption() {
      return this.lang !== 'ENG'
        ? this.disclosureInfo.image_caption
        : this.disclosureInfo.image_caption_em
        ? this.disclosureInfo.image_caption_em
        : this.disclosureInfo.image_caption_ea;
    },
    hasCaption() {
      return (
        this.disclosureInfo.image_caption &&
        this.disclosureInfo.image_caption !== 'null' &&
        this.disclosureInfo.image_caption !== ' '
      );
    },
    imageAlignmentClass() {
      const alignment = this.disclosureInfo.alignment;
      if (alignment === 'left') {
        return 'justify-content-start';
      } else if (alignment === 'right') {
        return 'justify-content-end';
      } else {
        return 'justify-content-center';
      }
    },
    imageUrl() {
      return this.disclosureInfo.image_url
        ? this.$store.state.static_host + this.disclosureInfo.image_url.replace(/\\/g, '/')
        : null;
    },
    imageUrlE() {
      return this.disclosureInfo.image_url_e
        ? this.$store.state.static_host + this.disclosureInfo.image_url_e.replace(/\\/g, '/')
        : null;
    },
    imageBoundaryOffsets() {
      const width = this.disclosureInfo.image_width || 100;
      let leftOffset, rightOffset;
      const alignment = this.disclosureInfo.alignment;
      if (alignment === 'left') {
        leftOffset = 0;
        rightOffset = width;
      } else if (alignment === 'center') {
        leftOffset = (100 - width) / 2;
        rightOffset = (100 - width) / 2 + width;
      } else {
        leftOffset = 100 - width;
        rightOffset = 100;
      }
      return { leftOffset: `${leftOffset}%`, rightOffset: `${rightOffset}%` };
    },
    titleStyle() {
      switch (this.disclosureInfo.title_alignment) {
        case 'text-start':
          return { textAlign: 'left' };
        case 'center':
          return { textAlign: 'center' };
        case 'text-end':
          return { textAlign: 'right' };
        case 'image-left':
          return {
            textAlign: 'left',
            marginLeft: this.imageBoundaryOffsets.leftOffset,
            marginRight: this.imageBoundaryOffsets.leftOffset
          };
        case 'image-right':
          return {
            textAlign: 'right',
            marginLeft: this.imageBoundaryOffsets.leftOffset,
            marginRight: this.imageBoundaryOffsets.leftOffset
          };
        default:
          return {};
      }
    },
    captionStyle() {
      switch (this.disclosureInfo.caption_alignment) {
        case 'text-start':
          return { textAlign: 'left' };
        case 'center':
          return { textAlign: 'center' };
        case 'text-end':
          return { textAlign: 'right' };
        case 'image-left':
          return {
            textAlign: 'left',
            marginLeft: this.imageBoundaryOffsets.leftOffset,
            marginRight: this.imageBoundaryOffsets.leftOffset
          };
        case 'image-right':
          return {
            textAlign: 'right',
            marginLeft: this.imageBoundaryOffsets.leftOffset,
            marginRight: this.imageBoundaryOffsets.leftOffset
          };
        default:
          return {};
      }
    }
  },
  methods: {
    openImgPopup(e) {
      const img = e.target;
      if (img.tagName === 'IMG') {
        this.$EventBus.$emit('image-modal', img.getAttribute('src'), true);
      }
    },
    onImageLoad() {
      this.$emit('image-loaded');
    }
  }
};
</script>

<style scoped>
h5,
p {
  white-space: pre-wrap; /* 줄바꿈 문자 유지하면서 자동 줄바꿈 */
  word-wrap: break-word; /* 단어 단위로 줄바꿈 */
  overflow-wrap: break-word; /* 단어 단위로 줄바꿈(신규 속성) */
}
</style>
